import { produce } from 'immer';
import { storageService } from 'js/services/storage.service';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultStateRaw: Types.IUserState = {
    isAlive: true,
    role: 'guest',
    isLoggedIn: false,
    userDetails: {},
    tags: [],
    toastTimeoutValue: 5,
    lang: window.Playtech.Methods.getUserLanguage()
};

const userStorageData: Types.IUserState = storageService.session.getItem('user');
const defaultState: Types.IUserState = { ...defaultStateRaw, ...userStorageData };

export const reducer = produce((draftState, action: Types.TUserAction): Types.IUserState | void => {
    switch (action.type) {
        case actionTypes.SET_COUNTRY: {
            draftState.country = action.payload;

            break;
        }
        case actionTypes.SET_COUNTRY_BY_GEO_IP: {
            draftState.country = draftState.country || action.payload;
            draftState.countrySetByGeoIp = action.payload;

            break;
        }
        case actionTypes.SET_GEO_DATA: {
            draftState.geoData = action.payload;

            break;
        }
        case actionTypes.SET_CLIENT_IP: {
            draftState.clientIp = action.payload;

            break;
        }
        case actionTypes.SET_IS_ALIVE: {
            draftState.isAlive = action.payload;

            break;
        }
        case actionTypes.SET_LANG: {
            draftState.lang = action.payload;

            break;
        }
        case actionTypes.SET_CURRENCY_CODE: {
            draftState.currencyCode = action.payload;

            break;
        }
        case actionTypes.SET_LEGACY_USER_DATA:
        case actionTypes.SET_ATTRIBUTES: {
            Object.assign(draftState, {
                ...action.payload
            });

            break;
        }
        case actionTypes.UNSET_ATTRIBUTE: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload]: toBeDeleted, ...state } = draftState;

            return state as Types.IUserState;
        }
        case actionTypes.SET_DETAILS: {
            const { userDetails, isForce } = action.payload;

            draftState.userDetails = isForce
                ? userDetails
                : { ...draftState.userDetails, ...userDetails };

            break;
        }
        case actionTypes.TOGGLE_BALANCE: {
            draftState.hideBalance = action.payload;

            break;
        }
        case actionTypes.RESET_TO_DEFAULT: {
             // have to preserve these properties
            // even when reset is happening
            const {
                lang,
                hideBalance,
                hasBeenLoggedIn,
                suspended,
                clientIp,
                daydepositlimit,
                weekdepositlimit,
                monthdepositlimit,
                currencyCode,
                country,
                countrySetByGeoIp,
                geoData,
                promoCode,
                registrationInfo,
                userAvailabilityVerificationToken,
                signUpVerificationToken
            } = draftState;

            return {
                ...defaultState,
                lang,
                hideBalance,
                hasBeenLoggedIn,
                suspended,
                clientIp,
                daydepositlimit,
                weekdepositlimit,
                monthdepositlimit,
                currencyCode,
                country,
                countrySetByGeoIp,
                geoData,
                promoCode,
                registrationInfo,
                userAvailabilityVerificationToken,
                signUpVerificationToken
            };
        }

        default: {
            break;
        }
    }
}, defaultState);
